import React from "react";
import styled from "styled-components";
import { AppText, FlexDiv } from "../../../ui";

interface ImageQuestionProps {
  title?: string;
  src: string;
  alt: string;
  height?: number;
}

const ImageQuestion: React.FC<ImageQuestionProps> = ({ title, ...rest }) => {
  return (
    <FlexDiv
      direction="column"
      justify="center"
      align="center"
      gap={64}
      mobileGap={56}
      style={{ height: "100%" }}
    >
      {title && (
        // minHeight is for the two onboarding images that have similar images. It ensures the images are aligned when transitioning from one image to another
        <AppText noMargin fontSize={24} mobileFontSize={20} style={{ maxWidth: 468, minHeight: 84 }}>
          {title}
        </AppText>
      )}
      <div>
        <Img hasText={!!title} {...rest} width={437} height={565} />
      </div>
    </FlexDiv>
  );
};

const Img = styled.img<{ hasText: boolean }>`
  height: 100%;
  /* height: 519px; */
  max-height: min(${props => (props.hasText ? 50 : 60)}dvh, 600px);
  margin: 0 auto;
  object-fit: contain;
`;

export default ImageQuestion;
